import BaseService from '@/services/BaseService';

class TechnicalInfoService extends BaseService {
    createTableHeader = (data) => this.post('/create-table-header', data);

    updateTableHeader = (data, id) => this.post(`/edit-table-header/${id}`, data);

    viewTableHeader = (id) => this.get(`/view-table-header/${id}`);

    getTableHeaderList = (data) => this.post(
        `/get-table-header-list?page=${data.page}&per_page=${data.per_page}`,
        { search: data.search } || {},
    );

    getParentHeaderList = (id) => this.get(`/get-parent-header-list/${id}`);
}

export default new TechnicalInfoService();
